module.exports = __webpack_public_path__ + "static/media/hongbang.caa4dc5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/TestimonialsCarousel/assets/partner/hongbang.png
// module id = 1107
// module chunks = 0